

<a-assets>

  <a-mixin id="snowbase"
  material="color:white"
  paintable
  geometry="primitive:sphere;segments-height:7;segments-width:13;radius:0.5"
  movement="type:static; stickiness:sticky">
</a-mixin>
<a-mixin id="snowball"
  material="color:white"
  paintable
  geometry="primitive:sphere;segments-height:7;segments-width:13;radius:0.5"
  movement="type:grabbable; stickiness:sticky">
</a-mixin>
<a-mixin id="coal"
  material="color:black"
  geometry="primitive:sphere;segments-height:7;segments-width:13;radius:0.04"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="carrot"
  material="color:orange"
  geometry="primitive:cone;height:0.2;radius-bottom:0.025; radius-top:0.005"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="hat"
  material="color:black"
  geometry="primitive:tophat-hollow"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="branch"
  material="color:#5C4033"
  geometry="primitive:branch"
  scale="0.2 0.2 0.2"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="tree-tier"
  material="color:green"
  geometry="primitive:cone;height:0.5;radius-bottom:0.5;segments-height:1;segments-radial:9"
  movement="type:static; stickiness:sticky">
</a-mixin>
<a-mixin id="trunk"
  material="color:#5C4033"
  geometry="primitive:cylinder;height:0.5;radius:0.1;">
</a-mixin>
<a-mixin id="star"
  material="color:yellow; metalness: 0.8; roughness:0.2"
  geometry="primitive:star; innerRadius:0.04;outerRadius:0.12;points:5;depth:0.01"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="bauble"
  movement="type:grabbable; stickiness:stickable">
</a-mixin>
<a-mixin id="marble-run-base"
  material="color:brown; metalness: 0.5; roughness:0.2"
  movement="type:static; stickiness:sticky2">
</a-mixin>
<a-mixin id="marble-run-ramp"
  material="color:orange; metalness: 0.5; roughness:0.2"
  movement="type:grabbable; stickiness:stickable2">
</a-mixin>
<a-mixin id="ribbon-large"
  geometry="primitive:ribbon;height: 0.4; depth:0.5; width:0.5; ribbon:0.06">
</a-mixin>
<a-mixin id="present-large"
  geometry="primitive:box;height: 0.4; depth:0.5; width:0.5"
  movement="type:grabbable; stickiness:none; initialState:dynamic">
</a-mixin>
<a-mixin id="ribbon-medium"
  geometry="primitive:ribbon;height: 0.2; depth:0.3; width:0.2; ribbon:0.05">
</a-mixin>
<a-mixin id="present-medium"
  geometry="primitive:box;height: 0.2; depth:0.3; width:0.2"
  movement="type:grabbable; stickiness:none; initialState:dynamic">
</a-mixin>
<a-mixin id="ribbon-small"
  geometry="primitive:ribbon;height: 0.1; depth:0.2; width:0.1; ribbon:0.04">
</a-mixin>
<a-mixin id="present-small"
  geometry="primitive:box;height: 0.1; depth:0.2; width:0.1"
  movement="type:grabbable; stickiness:none; initialState:dynamic">
</a-mixin>
<a-mixin id="ribbon-gold"
  material="color:yellow; metalness: 0.5; roughness:0.2">
</a-mixin>
<a-mixin id="ribbon-green"
  material="color:green; metalness: 0.5; roughness:0.2">
</a-mixin>
<a-mixin id="ribbon-blue"
  material="color:green; metalness: 0.5; roughness:0.2">
</a-mixin>
<a-mixin id="ribbon-red"
  material="color:red; metalness: 0.5; roughness:0.2">
</a-mixin>
<!-- <a-mixin id="penguin"
  penguin
  scale="0.1 0.1 0.1"
  movement="type:grabbable; stickiness:stickable; initialState:dynamic">
</a-mixin> -->
<a-mixin id="paintbrush"
  paintbrush="color:blue"
  scale="0.05 0.05 0.05">
</a-mixin>


    <a-cubemap id="env">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-left.png">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-left.png">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-top.png">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-bottom.png">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-back.png">
        <!-- svelte-ignore a11y-missing-attribute -->
        <img src="./assets/environment-back.png">
      </a-cubemap>
<!-- svelte-ignore a11y-missing-attribute -->
<img id="snow" src="data:image/jpeg;base64,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">
</a-assets>